export const useLocale = locale => {
  return {
    isEngland: locale === 'en-uk',
    isSpain: locale === 'es-es',
    isFinland: locale === 'fi-fi',
    isIreland: locale === 'en-ir',
    isItaly: locale === 'it-it',
  };
};
